/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-magic-numbers */
import React from 'react'

const CarouselSlide = ({ children, mobileWidth, tabletWidth, desktopWidth, index }) => {
  return (
    <div
      data-eevee-carousel-index={index}
      className='eevee-carousel-slide'
      sx={{
        flexShrink: 0,
        width: [mobileWidth, tabletWidth, desktopWidth],
        minHeight: 400,
        maxHeight: 550,
        mr: 'lg',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        scrollSnapAlign: 'center',
        py: 'lg',
        '> span': {
          // this is because hydration wraps the children in a span that stops the flex getting applied
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'stretch',

          '> div': {
            width: '100%',
          },
        },
      }}
    >
      {children}
    </div>
  )
}

const Carousel = ({ colsMobile = 2, colsTablet = 2, colsDesktop = 2, children }) => {
  const mobileWidth = `${100 / colsMobile}%`
  const tabletWidth = `${100 / colsTablet}%`
  const desktopWidth = `${100 / colsDesktop}%`
  return (
    <div sx={{ my: 'sm' }} className='eevee-carousel-wrapper'>
      <div
        className='eevee-carousel-rail'
        sx={{
          display: 'flex',
          overflowX: 'auto',
          scrollSnapType: 'x mandatory',
          scrollBehavior: 'smooth',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {React.Children.map(children, (child, i) => (
          <CarouselSlide
            key={`img-${i}`}
            index={i}
            mobileWidth={mobileWidth}
            tabletWidth={tabletWidth}
            desktopWidth={desktopWidth}
          >
            {child}
          </CarouselSlide>
        ))}
      </div>

      <div sx={{ display: 'flex', justifyContent: 'center' }}>
        {React.Children.map(children, (entry, i) => (
          <div
            className={
              i === 0 ? 'eevee-carousel-dot eevee-carousel-active-dot' : 'eevee-carousel-dot'
            }
            role='button'
            sx={{
              display: 'inline-flex',
              minWidth: '12px',
              height: '12px',
              background: '#ccc',
              textDecoration: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              mr: 'xs',
              position: 'relative',
              cursor: 'pointer',
              '&.eevee-carousel-active-dot': {
                background: 'black',
              },
            }}
            key={`slide-${i + 1}`}
            tabIndex={i + 1}
          />
        ))}
      </div>
    </div>
  )
}

export default Carousel
